// extracted by mini-css-extract-plugin
module.exports = {"navbar":"style-module--navbar--2jf1s","links":"style-module--links--3hbwx","language":"style-module--language--NeHte"};